module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Penelope Lively\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Penelope Lively is the author of over twenty books of fiction and nonfiction, including the Booker Prize–winning novel "), _c('I', [_vm._v("Moon Tiger")]), _vm._v(" and the Whitbread Award–winning novel "), _c('I', [_vm._v("A Stitch in Time,")]), _vm._v(" as well as numerous children's books.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jFRo8j/tc-custom/9780802197382.jpg?1728326945682",
      "alt": "This image is the cover for the book Judgment Day"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Judgment Day\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This “beautiful and brilliant novel” follows an agnostic woman’s relationship with a religious village’s people and its past (Auberon Waugh).")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Judgment Day")]), _vm._v(" takes us into the life of Clare Paling, who has just moved with her family to Laddenham, a sleepy village enlivened only by sideshows of adultery and gossip. An avowed agnostic, Clare is nonetheless caught up in the restoration of the church, even inciting the villagers to put on a pageant that recreates the church’s dark history."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With flawless precision, Penelope Lively brings the village and its inhabitants to life as an unpardonable death reminds them all that the world is a very uncertain place."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" [Lively is] blessed with the gift of being able to render matters of great import with a breath, a barely audible sigh, a touch. The result is wonderful writing.” —"), _c('i', [_vm._v("The New York Times Book Review")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0